import React from "react";

const EndSidebar = () => {
  // return (
  //   <>
  //     <main id="main" className="main">
  //       <div className="pagetitle">
  //         <h1>ApexCharts</h1>
  //         <nav>
  //           <ol className="breadcrumb">
  //             <li className="breadcrumb-item">
  //               <a href="index.html">Home</a>
  //             </li>
  //             <li className="breadcrumb-item">Charts</li>
  //             <li className="breadcrumb-item active">ApexCharts</li>
  //           </ol>
  //         </nav>
  //       </div>
  //       {/* End Page Title */}
  //       <p>
  //         ApexCharts Examples. You can check the{" "}
  //         <a
  //           href="https://apexcharts.com/javascript-chart-demos/"
  //           target="_blank"
  //         >
  //           official website
  //         </a>{" "}
  //         for more examples.
  //       </p>
  //       <section className="section">
  //         <div className="row">
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Line Chart</h5>
  //                 {/* Line Chart */}
  //                 <div id="lineChart" />
  //                 {/* End Line Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Area Chart</h5>
  //                 {/* Area Chart */}
  //                 <div id="areaChart" />
  //                 {/* End Area Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Column Chart</h5>
  //                 {/* Column Chart */}
  //                 <div id="columnChart" />
  //                 {/* End Column Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Bar Chart</h5>
  //                 {/* Bar Chart */}
  //                 <div id="barChart" />
  //                 {/* End Bar Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Pie Chart</h5>
  //                 {/* Pie Chart */}
  //                 <div id="pieChart" />
  //                 {/* End Pie Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Donut Chart</h5>
  //                 {/* Donut Chart */}
  //                 <div id="donutChart" />
  //                 {/* End Donut Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Radar Chart</h5>
  //                 {/* Radar Chart */}
  //                 <div id="radarChart" />
  //                 {/* End Radar Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Polar Area Chart</h5>
  //                 {/* Polar Area Chart */}
  //                 <div id="polarAreaChart" />
  //                 {/* End Polar Area Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Radial Bar Chart</h5>
  //                 {/* Radial Bar Chart */}
  //                 <div id="radialBarChart" />
  //                 {/* End Radial Bar Chart */}
  //               </div>
  //             </div>
  //           </div>
  //           <div className="col-lg-6">
  //             <div className="card">
  //               <div className="card-body">
  //                 <h5 className="card-title">Bubble Chart</h5>
  //                 {/* Bubble Chart */}
  //                 <div id="bubbleChart" />
  //                 {/* End Bubble Chart */}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       </section>
  //     </main>
  //   </>
  // );
};

export default EndSidebar;
